import { Component, OnInit } from '@angular/core';
import { LoaderFacadeService } from '@store/root-store/loader/loader-facade.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    standalone: false
})
export class LoaderComponent implements OnInit {
  loaderState$: Observable<boolean>;

  constructor(private loaderFacade: LoaderFacadeService) {}

  ngOnInit() {
    this.loaderState$ = this.loaderFacade.global$;
  }
}
